<template>
    <div class="cc-carriers">
        <div class="cc-content cc-content--errors mb-4" v-if="countryMismatch">
          <div class="cc-alert cc-alert--error cc-alert--with-background">{{ translations['You have selected delivery country which is different than delivery country selected in your account. Please choose new carrier and payment type, or select another country if needed.'] }}</div>
        </div>
        <div class="cc-carriers__header">
            <div class="cc-carriers__title cc-title cc-title--section">{{ translations['Carriers'] }}</div>
            <a class="cc-carriers__change cc-link" v-if="selectedCarrier" @click="unsetCarrier">{{ translations['Change carrier'] }}</a>
        </div>
        <div class="cc-carriers__main" v-if="display">
            <grouped-single-pickup-in-store :carriers="groupedPickupInStoreCarriers"/>
            <carrier v-for="carrier in notPickupInStoreCarriers" v-bind:key="carrier.id_carrier" :carrier="carrier"/>
        </div>
        <div class="cc-carriers__alerts" v-if="!display">
            <div class="cc-alert cc-alert--information">{{ translations['Please select country to show available carriers'] }}</div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

import Carrier from "./Carrier";
import GroupedSinglePickupInStore from "@/components/Store919/GroupedSinglePickupInStore";

export default {
        components: {
          GroupedSinglePickupInStore,
            Carrier,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                carriers: state => state.carriers,
                user: state => state.user,
                selectedCarrier: state => state.selectedCarrier,
                countryMismatch: state => state.errors.loginCountryMismatch,
            }),
            display: function () {
                return this.user.deliveryAddress.country && this.carriers && this.carriers.length;
            },
            notPickupInStoreCarriers: function () {
              return this.carriers.filter(carrier => !carrier.groupToSinglePickupInStore);
            },
            groupedPickupInStoreCarriers: function () {
              return this.carriers.filter(carrier => carrier.groupToSinglePickupInStore);
            },
        },
        methods: {
            unsetCarrier: function () {
                this.$store.dispatch('SELECT_CARRIER', null);
                this.$store.dispatch('SELECT_PAYMENT', null);
                this.$store.commit('SET_LOCK_DELIVERY_POSTAL_CODE',false)
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/carriers";
</style>
